import { Engine } from '../../core/Engine';
import { MoveToCommand } from '../Commands';

export class MoveToCommandHandler {
    private engine: Engine;

    constructor(engine: Engine) {
        this.engine = engine;
    }

    handle(command: MoveToCommand) {
        const obj = this.engine.find(command.uuid);
        //obj.moveTo(command.position, this.engine);
    }
}
